module.exports = __webpack_public_path__ + "static/media/how-it-work.9cf912bc.png";